export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
  }
}

export class SumupSheet {
  room_name: number
  student_count: number
  allot: number
  min_score: number
  max_score: number
  score_average: number
  score_rate: number

  constructor(sumupSheet: any){
    this.room_name = sumupSheet.room_name;
    this.student_count = sumupSheet.student_count;
    this.allot = sumupSheet.allot;
    this.min_score = sumupSheet.min_score;
    this.max_score = sumupSheet.max_score;
    this.score_average = sumupSheet.score_average;
    this.score_rate = sumupSheet.score_rate;
  }
}